import Experiments from '@wix/wix-experiments';
import { compose } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { withExperiments } from '@wix/wix-experiments-react';
import {
  selectApplePayCountryCode,
  selectApplePayMerchantCapabilities,
  selectApplePaySupportedNetworks,
  selectTopProps,
  selectOnClick,
  selectApplePayBtnColor,
  selectSessionId,
} from '../../../selectors';
import { StoreState } from '../../../types/StoreState';
import { withBiLogger } from '../../Hoc/BiLogger';
import { startApplePayFlow } from '../../../actions/payment/startApplePayFlow';
import { BiLogger } from '../../Hoc/BiLogger/BiLoggerProvider';
import { withFedopsLogger } from '../../Hoc/Fedops/withFedopsLogger';
import { WidgetFedopsLogger } from '../../Hoc/Fedops/FedopsProvider';
import { ApplePayController } from './controller';

const mapState = (state: StoreState) => {
  return {
    countryCode: selectApplePayCountryCode(state),
    merchantCapabilities: selectApplePayMerchantCapabilities(state),
    supportedNetworks: selectApplePaySupportedNetworks(state),
    topProps: selectTopProps(state),
    onClick: selectOnClick(state),
    color: selectApplePayBtnColor(state),
    sessionId: selectSessionId(state),
  };
};
const mapDispatch = {
  startApplePayFlow,
};
const connector = connect(mapState, mapDispatch);
export type Props = ConnectedProps<typeof connector> & {
  biLogger: BiLogger;
  fedopsLogger: WidgetFedopsLogger;
  experiments: Experiments;
};
export const ApplePayControllerConnect = compose<React.ComponentType<{}>>(
  connector,
  withBiLogger,
  withFedopsLogger,
  withExperiments,
)(ApplePayController);
